import { Config } from "./types";

const config: Config = {
    //dashboardUrl: "https://dashboard.fitforwork.ai",
    dashboardSubdomain: "dashboard",
    googleAnalyticsId: "UA-172673030-1",
};

export default config;
